/* Product page size selection on phones (see giorgio-suit-mobile.css).
   - After the jacket is confirmed, the pants picker opens straight away if no waist is chosen yet.
   - Complete the look: each piece shows a "Choose size" button; its size menus open on tap.
     "Add the full look" opens every piece so any missing size is visible. */
(() => {
  const small = window.matchMedia('(max-width: 989px)');

  // Jacket confirmed -> if the selector couldn't fill in a waist (it suggests the standard pairing when it can),
  // open the pants picker straight away.
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!small.matches || !(dialog instanceof HTMLDialogElement)) return;
    if (dialog.dataset.gSuitKind !== 'jacket' || dialog.gSuitCommitted !== true) return;
    const product = dialog.closest('.g-product') || document;
    const pantButton = product.querySelector('.g-suit-choice[aria-controls$="-pant"]');
    const pantDialog = product.querySelector('dialog[data-g-suit-kind="pant"]');
    if (!pantButton || !pantDialog) return;
    setTimeout(() => {
      const summary = pantButton.querySelector('.g-suit-choice-summary')?.textContent || '';
      if (!pantDialog.open && /select/i.test(summary)) pantButton.click();
    }, 120);
  }, true);

  // Complete the look rows.
  const enhanceLook = () => {
    document.querySelectorAll('.g-look-row').forEach((row) => {
      if (row.querySelector('.g-look-row__choose')) return;
      const fields = row.querySelector('.g-look-row__fields');
      const add = row.querySelector('.g-look-row__add');
      if (!fields || !add || !fields.querySelector('select')) { row.classList.add('is-open'); return; }
      fields.id = fields.id || `GiorgioLookFields-${Math.random().toString(36).slice(2, 8)}`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'g-look-row__choose';
      btn.textContent = 'Choose size';
      const kind = row.querySelector('.g-look-row__kind')?.textContent.trim();
      if (kind) btn.setAttribute('aria-label', `Choose size — ${kind}`);
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', fields.id);
      btn.addEventListener('click', () => {
        row.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        fields.querySelector('select')?.focus();
      });
      add.before(btn);
    });
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('.g-look__all')) return;
    document.querySelectorAll('.g-look-row').forEach((row) => {
      row.classList.add('is-open');
      row.querySelector('.g-look-row__choose')?.setAttribute('aria-expanded', 'true');
    });
  }, true);

  const start = () => {
    enhanceLook();
    const look = document.querySelector('.g-look');
    if (look) new MutationObserver(enhanceLook).observe(look, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
